import React from 'react'
import { Navbar, Nav, Button } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/sosLogo.svg';

const HeaderComponent = (props) => {
    let navigate = useNavigate();
    const { setUser } = useAuth();
    const { user } = useAuth();
 
    const handleLogout = () => {
        localStorage.clear();
        setUser(null);
        navigate('/');
    };
    
    return (
        <div>
            <Navbar bg="dark" variant="dark">
                <Nav className="mr-auto">
                    <Navbar.Brand>
                        <img
                            src={logo}
                            width="30"
                            height="30"
                            className="d-inline-block align-top"
                            alt="React Bootstrap logo"
                        />{' '}
                        Notfall App Tracking
                    </Navbar.Brand>
                    
                   
                </Nav>
                {user != null &&
                    <Button onClick={handleLogout} variant="outline-danger">Abmelden</Button>
                }
                
            </Navbar>
        </div>
    )
}

export default HeaderComponent